import {html, css, LitElement, live, ref, createRef } from 'lit';

export class AmountInput extends LitElement {

    $input = createRef()

    static styles = css`
        :host {
            display: inline-flex;
        }

        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type="number"] {
            -moz-appearance: textfield;
            border-radius: 0px;
        }

        input[type="number"]:focus {
            outline: none;
            background: #007dff1c;
        }
        
        input {
            width: 100%;
        }
    `;

    static properties = {
        min:   {type: Number},
        max:   {type: Number},
        step:  {type: Number},
        real:  {type: Boolean},        
        value: {type: Number, reflect: true, hasChanged(newval, oldval) {
            return true
        }},
        autofocus: {type: Boolean}
    };

    constructor() {
        super();
        this.min   = 1
        this.max   = Number.MAX_SAFE_INTEGER
        this.step  = 1
        this.value = 1
        this.real  = true
        this.default = 0
        this.autofocus = false
        this.quick = true

        this.addEventListener("keydown", evt => {
            if (evt.key === "Enter") {
                this.change(evt)
            }
        })
    }

    render() {
        return html`
            <slot name="minus" @click="${this.decrement}"></slot>
            <input type="number" 
                .value=${live(this.value)} 
                ${ref(this.$input)}
                style="color: ${Number(this.value) || !this.quick ? "black" : "transparent" }"
                part="input" 
                @change=${this.change} 
                @input=${this.filter}
                @focus=${this.focus}
                @blur=${this.blur}
                > 
            <slot name="plus" @click="${this.increment}"></slot>
        `
    }

    firstUpdated() {
        if (this.autofocus) {
            this.$input.value.focus()
        }
    }

    changeEvent() {
        let custom_evt = new CustomEvent("change", {composed: true, detail: this.value})
        this.dispatchEvent(custom_evt)
    }

    focus() {
        if (this.quick) {
            if (this.$input.value) {
                this.$input.value.value = ""
            }
        }
    }

    blur() {
        if (this.$input.value) {
            if (Number(this.$input.value.value) > 0) {
                this.value = this.clip(Number(this.$input.value.value))
            } else {
                this.$input.value.value = this.value
            }
        }
    }

    clip(value) {
        return Math.min(this.max, Math.max(this.min, Math.round(value)))
    }

    filter(evt) {
        evt.target.value = Number(evt.target.value).toString()
    }

    change(evt) {
        this.value = this.clip(Number(evt.target.value))
        this.changeEvent()
        this.$input.value.blur()
    }

    increment() {
        this.value = this.clip(this.value + this.step)
        this.changeEvent()
    }

    decrement() {
        this.value = this.clip(this.value - this.step)
        this.changeEvent()
    }
}

customElements.define('amount-input', AmountInput);